import { render } from "./ChangeTypeForm.vue?vue&type=template&id=ef474a2a"
import script from "./ChangeTypeForm.vue?vue&type=script&lang=js"
export * from "./ChangeTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__